import { ObjectManagementModule, ReduxUtils, CodeSnippetBackgroundStyle } from 'UI-Dash-Commons-UI';
import * as constants from './constants';
import MediationDocsState from '../types/MediationDocsState';

const initialMediationDocsState: MediationDocsState = {
    codeSnippetBackgroundStyle: CodeSnippetBackgroundStyle.LIGHT,

    networks: ObjectManagementModule.ObjectStateReducerUtils.getInitialState(),
    skAdnetworkIds: ObjectManagementModule.ObjectStateReducerUtils.getInitialState(),
    sdkKey: ObjectManagementModule.ObjectStateReducerUtils.getInitialState(),
    safedkKey: ObjectManagementModule.ObjectStateReducerUtils.getInitialState(),
};

const onToggleCodeSnippetBackgroundStyle = ( state: MediationDocsState, action: any ): MediationDocsState =>
( {
    ...state,

    codeSnippetBackgroundStyle: action.codeSnippetBackgroundStyle,
} );

const mediationDocsReducer = ReduxUtils.createReducer( initialMediationDocsState, {
    [ constants.ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE]: onToggleCodeSnippetBackgroundStyle,

    ...ObjectManagementModule.ObjectStateReducerUtils.createHandlers( 'networks' ),
    ...ObjectManagementModule.ObjectStateReducerUtils.createHandlers( 'skAdnetworkIds' ),
    ...ObjectManagementModule.ObjectStateReducerUtils.createHandlers( 'sdkKey' ),
    ...ObjectManagementModule.ObjectStateReducerUtils.createHandlers( 'safedkKey' ),
} );

export default mediationDocsReducer;
